module.exports = __webpack_public_path__ + "img/norecord.aa32dc08.svg";